__webpack_require__.p = "/thesis_assessment_criteria/";